<template>
  <div class="col-xl-3 col-6 col-sm-4 col-md-3 mb-2 px-md-2">
    <label class="kt-option" :class="[complexity.id === complexityModel ? 'border-blue' : '']">
      <span class="kt-option__control mb-2" style="display: none;" :class="{ 'mt-4': !quotationRequest}">
          <input
            type="radio"
            v-model.number="complexityModel"
            :value="complexity.id"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
          />
      </span>

      <span class="kt-option__label">
        <span class="kt-option__head">
          <img v-if="quotationRequest" src="@/assets/media/not-sure.jpeg" class="mx-auto" alt/>
          <img v-else :src=" complexity.sample " class="mx-auto" alt/>
        </span>
        <span class="kt-option__body text-center">
          <h3>{{ complexity.title }}</h3>
          <h5 v-if="!quotationRequest">${{ complexity.price }} per image</h5>
          <h5 v-else>Let us quote you</h5>
        </span>

        <span v-if="!quotationRequest" class="kt-option__body text-center">
<!--          <button type="button" class="btn btn-secondary btn-icon mr-2">-->
<!--            <ImgSvg />-->
<!--          </button>-->
          <button type="button" class="btn btn-secondary btn-icon" data-toggle="modal" :data-target="'#kt_modal_' + complexity.id ">
            <InfoSvg />
          </button> 
          <button  v-if="complexity && complexity.sample_images && complexity.sample_images.length" type="button" class="btn btn-secondary btn-icon" data-toggle="modal" :data-target="'#samples_' + complexity.id ">
             <ImgSvg />
          </button>
        </span>
        <span v-else>
          <p class="p-2 small text-center">We will review and propose complexity levels.</p>
        </span>
      </span>
    </label>

    <div class="modal fade" tabindex="-1" :id="'kt_modal_' + complexity.id ">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">What do we mean by "{{ complexity.title }}"</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <p v-html="description"></p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" :id="'samples_' + complexity.id ">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Sample Images -  "{{ complexity.title }}"</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body"> 
            <Slider v-if="complexity && complexity.sample_images && complexity.sample_images.length" :sampleImages="complexity.sample_images"></Slider>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

import ImgSvg from "@/svgs/ImgSvg.vue"; 
import InfoSvg from "@/svgs/InfoSvg.vue";
import Slider from "./Slider.vue";
let support = require('../helpers/support');

export default {
  name: "ComplexityType",
  components: {
     ImgSvg,
    InfoSvg,
    Slider
  },
  props: {
    complexity: {
      type: Object,
      required: true,
    },
    value: {
      default: null,
    },
    quotationRequest: {
      default: false,
    },
  },
  data() {
    return {
      complexityModel: null,
    };
  },
  computed: {
    description: function () {
      return support.nl2br(this.complexity.description);
    }
  },
  mounted(){ 
  },
  watch: {
    value() {
      this.complexityModel = this.value;
    },
  },
};
</script>
<style lang="scss">
.kt-option__head img {
  max-width: 100%;
}
.kt-option {
  padding: 0;
  padding-bottom: 1.4em;
  flex-direction: column-reverse;
  align-items: center;
}
.kt-option:hover {
  border-color: #5d78ff;
}
.border-blue {
  border-color: #5d78ff;
}

</style>
